import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  padding-right: ${(p) => p.theme.spacing(2)};
  border-radius: ${(p) => p.theme.spacing(1)};
  box-shadow: ${(p) => p.theme.spacing(0, 0, 0, 0.5)}${(p) => p.theme.palette.primary[100]};
  background: var(
    --G_1,
    linear-gradient(
      150deg,
      ${(p) => p.theme.palette.primary[300]} 14.93%,
      #41568f 111.7%
    )
  );
  color: ${(p) => p.theme.palette.common.white};
  padding: ${(p) => p.theme.spacing(1.75, 1.5, 1.75, 1.5)};

  &.isLowOnCredit {
    background: var(
      --G_1,
      linear-gradient(
        150deg,
        ${(p) => p.theme.palette.warning[50]} 14.93%,
        ${(p) => p.theme.palette.warning[200]} 111.7%
      )
    );
    box-shadow: ${(p) => p.theme.spacing(0, 0, 0, 0.5)}${(p) => p.theme.palette.warning[50]};
    color: ${(p) => p.theme.palette.warning[700]} !important;
  }

  &.isFree {
    background: var(
      --G_1,
      linear-gradient(
        150deg,
        ${(p) => p.theme.palette.primary[300]} 14.93%,
        #41568f 111.7%
      )
    );
    box-shadow: ${(p) => p.theme.spacing(0, 0, 0, 0.5)}${(p) => p.theme.palette.primary[100]};
  }

  &.isExpired {
    background: var(
      --G_1,
      linear-gradient(
        150deg,
        ${(p) => p.theme.palette.error[300]} 14.93%,
        #b23030 111.7%
      )
    );
    color: ${(p) => p.theme.palette.common.white};
    box-shadow: 0px 0px 0px ${(p) => p.theme.spacing(0.5)}${(p) => p.theme.palette.error[100]};
  }
`;

export const Logo = styled('img')`
  width: ${(p) => p.theme.spacing(4)};
`;
